import { Modal, TextField, Link, Toast } from "@shopify/polaris";
import React, { useState, useEffect, useCallback } from "react";
import intl from "../../../../../i18n/intl";
import {
  reqPostNewImportProduct,
  reqPostNewBaImportProduct
} from '../../../../../api'
import utils from '../../../../../utils/utils'
/**
 *
 * @param {Object} data
 * data.open 弹窗开关状态
 * data.type 1 导入 2删除 345批量操作collections, tags, product type
 * data.count 选中的数量
 * @param {Function} onChange
 * 弹窗回调
 *
 */
const ImportFormOther = ({ data, onChange }) => {
  const { open, type,from } = data;
  const [active, setActive] = useState(open); // 弹窗状态
  const [value, setValue] = useState(""); // 文本框的值
  const [error, setError] = useState(false); // 文本框是否错误
  const [loading, setLoading] = useState(false); // add 按钮loading

  const handleChangeTextField = useCallback((newValue) => {
    if (newValue?.length > 500) {
      return;
    }
    setValue(newValue);
    setError(!newValue)
  }, []);
  const [showToast, setShowToast] = useState(false);
  const [showToastText, setShowToastText] = useState("");
  const [showToastIserror, setShowToastIserror] = useState(false);
   //提示弹窗
   const toggleToast = (showToastText, showToastIserror = false) => {
      setShowToast(!showToast);
      setShowToastText(showToastText);
      setShowToastIserror(showToastIserror);
    };

    const toastMarkup = showToast ? (
      <Toast
        content={showToastText}
        onDismiss={() => toggleToast("")}
        error={showToastIserror}
      />
    ) : null;

  useEffect(() => {
    setActive(open);
  }, [open]);
  // 弹窗关闭回调
  const handleChange = () => {
    setActive(!active);
    onChange(type, !active);
    setError(false);
    setValue("");
  };
  // 弹窗关闭回调
  const handleChangeoff = () => {
    setActive(!active);
    onChange('dropshipman', !active);
    setError(false);
    setValue("");
  };

  // 处理添加产品事件
  const handleAddProduct = async () => {
    // 输入框为空
    if (!value) {
      setError(true);
      return;
    }
    setLoading(true);
    setError(false);

    const params = {
      encoded: value
    }
    if (type === 'AliExpress') {
      
      const response = await reqPostNewImportProduct(params)
      
      setLoading(false);
    if(response.code === '200') {
      handleChange();
      toggleToast('Product is importing')
      if (from) {
        utils.routeListen(
          "/admin/import-list?type=Listed"
        );
        utils.routeJump(
          this,
          "/admin/import-list?type=Listed"
        );
      }
    } else {
      toggleToast('Product already imported')
    }
    }
    if (type === '1688') {
      const response = await reqPostNewBaImportProduct({target:value})
      setLoading(false);
    if(response.code === '200') {
      handleChange();
      toggleToast('Product is importing')
    } else {
      toggleToast('Product already imported')
    }
    }
    
    

    // // 模拟接口
    // setTimeout(() => {
    //   setToast(false);
    //   // ALiExpress

    //   let mockData = Math.ceil(Math.round(Math.random()*3)).toString();
    //   /**
    //    * "1" 无法获取商品
    //    * "2" 1688 侵权
    //    * "3" 1688 翻译失败
    //    */
    //   if (mockData === "1" || (type === "1688" && mockData === "2") || (type === "1688" && mockData === "3")) {
    //     // 无法获取商品
    //     setToastError(true);
    //     setToastMsg(
    //       intl.get(
    //         mockData === "1" ? "The system can't get the product, please try again after changing other product URL or ID." : (type === "1688" && mockData === "2") ? "This product is suspected of infringement and is not supported to be added to the product list." : "There is an error in the system, please try again later."
    //       )
    //     );
    //     setToast(true);
    //   } else {
    //     setToastError(false);
    //     setToastMsg(intl.get("Success"));
    //     setToast(true);
    //     handleChange();
    //   }
    //   setLoading(false);
    // }, 500);
  };

  return (
    <>
      <Modal
        open={active}
        onClose={() => handleChangeoff()}
        title={intl.get("Import products from {{type}}", type)}
        primaryAction={{
          content: intl.get("Add Product"),
          onAction: () => handleAddProduct(),
          loading,
        }}
      >
        <Modal.Section>
          <p style={{ marginBottom: "1.5rem" }}>
            {type === "1688" ? intl.get(
              "Through the 1688 product link or ID, you can add 1688 products and import them to your store. And orders for the product will be fulfilled by Dropshipman.") : intl.get(
              "Through the AliExpress product link or ID, you can add AliExpress products and import them to your store. And orders for the product will be fulfilled by Dropshipman.")}
          </p>
          <TextField
            labelHidden
            value={value}
            maxLength={500}
            error={
              error
                ? intl.get("{{type}} product URL or ID required.", type)
                : null
            }
            onChange={handleChangeTextField}
            placeholder={intl.get(
              "Paste {{type}} product link or ID to here",
              type
            )}
            autoComplete="off"
            showCharacterCount
          />
          <div style={{ textAlign: "center", marginTop: "1.5rem" }}>
            <Link
              url={
                type === "1688"
                  ? "https://www.1688.com"
                  : "https://www.aliexpress.us"
              }
              external
            >
              {type === "1688"
                ? "https://www.1688.com"
                : "https://www.aliexpress.us"}
            </Link>
          </div>
        </Modal.Section>
      </Modal>
      {toastMarkup}
    </>
  );
};

export default ImportFormOther;
